<template>
  <div
    ref="container"
  >
    <slot />
    <!-- <AppFooter :legal-items="pageData?.legalItems" /> -->
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
</style>
